import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

const selectBulkSchedule = createSelector(
  (state) => state.BulkSchedule,
  (bs) => ({ taskId: bs.taskId, taskStatus: bs.taskStatus })
);

const BulkNotification = () => {
  const navigate = useNavigate();
  const { taskId, taskStatus } = useSelector(selectBulkSchedule);
  const selectToken = createSelector((state) => state.Login, (l) => l.token);
  const token = useSelector(selectToken);

  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [progress, setProgress] = useState(100);
  const timerRef = useRef(null);
  const esRef = useRef(null);

  useEffect(() => {
    if (!taskId || !token) return;

    const authToken = token?.Authorization ?? token?.authorization ?? "";
    const url = `/api/v2/taxi/bulk-schedule/sse/tasks/${taskId}/notifications${
      authToken ? `?token=${encodeURIComponent(authToken)}` : ""
    }`;

    const es = new EventSource(url);
    esRef.current = es;

    es.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        if (data.status === "done" || data.status === "error") {
          const msg =
            data.status === "done"
              ? "Programación masiva completada"
              : "Error en la programación masiva";
          showToast(msg, taskId);
          es.close();
        }
      } catch (_) {
        // non-JSON heartbeat frame, ignore
      }
    };

    es.onerror = () => es.close();

    return () => {
      es.close();
    };
  }, [taskId]);

  const showToast = (msg, id) => {
    setMessage(msg);
    setVisible(true);
    setProgress(100);

    let pct = 100;
    timerRef.current = setInterval(() => {
      pct -= 100 / 30;
      setProgress(Math.max(0, pct));
      if (pct <= 0) {
        clearInterval(timerRef.current);
        setVisible(false);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(timerRef.current);
      setVisible(false);
    }, 3000);
  };

  if (!visible) return null;

  return (
    <div
      className="bulk-notification"
      onClick={() => {
        clearInterval(timerRef.current);
        setVisible(false);
        navigate(`/services/bulk-schedule/tasks/${taskId}`);
      }}
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 9999,
        cursor: "pointer",
        background: "#fff",
        borderRadius: 8,
        boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
        padding: "12px 16px",
        minWidth: 260,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <i className="mdi mdi-bell-outline" style={{ fontSize: 18, color: "#f46a6a" }} />
        <span style={{ fontWeight: 600, fontSize: 14 }}>{message}</span>
      </div>
      <div style={{ height: 3, background: "#f0f0f0", borderRadius: 2, overflow: "hidden" }}>
        <div style={{ height: "100%", width: `${progress}%`, background: "#556ee6", transition: "width 0.1s linear" }} />
      </div>
      <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>Clic para ver el detalle</div>
    </div>
  );
};

export default BulkNotification;
